import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	title: {
		id: 'products-jsw-configuration-main.features-section.local-device-cache.title',
		defaultMessage: 'Store Jira data on your own device',
		description: 'The main title shown for the feature',
	},
	description: {
		id: 'products-jsw-configuration-main.features-section.local-device-cache.description',
		defaultMessage:
			'Store frequently accessed data on your device to help your Jira board and backlog load faster. This setting applies to all users on your Jira site. When the setting is turned off, any stored data will be deleted. <button>How will my data be stored?</button>',
		description: 'Description of the feature',
	},
	toggleLabelOptingIn: {
		id: 'products-jsw-configuration-main.features-section.local-device-cache.toggle-label-opting-in',
		defaultMessage: 'Toggle on local device cache',
		description: 'Button to toggle the feature on',
	},
	toggleLabelOptingOut: {
		id: 'products-jsw-configuration-main.features-section.local-device-cache.toggle-label-opting-out',
		defaultMessage: 'Toggle off local device cache',
		description: 'Button to toggle the feature off',
	},
});
